import axios from "axios";
import Swal from "sweetalert2";

const {
    REACT_APP_URI_MASSIVE_STAFF_UPLOAD: MASSIVE_STAFF_UPLOAD_URL,
    REACT_APP_URI_SUPPLIER_STAFF: SUPPLIER_STAFF_URL,
    REACT_APP_URI_SUPPLIER_STAFF_DETAILS: SUPPLIER_STAFF_DETAILS_URL,
    REACT_APP_URI_SUPPLIER_STAFF_PAYROLL: SUPPLIER_STAFF_PAYROLL_URL
} = process.env;

export const fetchStaffList = async ({ supplierId, query }) => {
    Swal.fire({
        footer: 'Loading, please wait',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });
    
    try {
        const { data } = await axios.get(`${SUPPLIER_STAFF_URL}${supplierId}?${query.toString()}`)
        
        Swal.close();
        return data ?? []
    } catch (error) {
        Swal.close();
        
        // Mostrar SweetAlert de error
        Swal.fire({
            icon: 'error',
            title: 'Error loading staff list',
            text: error.response?.data?.message || error.message || 'An unexpected error occurred',
            showConfirmButton: true,
            confirmButtonText: 'OK',
        });
        
        // Re-lanzar el error para que React Query lo maneje
        throw error;
    }
}

export const massiveStaffUploadService = async ({ supplierId, entityId, file }) => {
	const allowedExtensions = /(\.xlsx|\.xls)$/i;

	if (!file) {
        throw new Error('No file provided');
	}

	if (!allowedExtensions.exec(file.name)) {
		throw new Error('Please select an Excel file.');
	}

	const formData = new FormData();

    formData.append("entityId", entityId);
	formData.append("document", file);

    const res = await axios.patch(`${MASSIVE_STAFF_UPLOAD_URL}${supplierId}`, formData);

    return res.data;
}

export const postStaff = async ({ supplierId, entityId, staffData }) => {
    const { data } = await axios.post(`${SUPPLIER_STAFF_URL}${supplierId}`, {
        staffData,
        entityId
    })
    
    return data
}

export const toggleStaffStatus = async ({ assignmentId }) => {
    const { data } = await axios.patch(`${SUPPLIER_STAFF_URL}toggleActive/${assignmentId}`);

    return data;
}

export const removeStaffAssignment = async ({ assignmentId }) => {
    const { data } = await axios.delete(`${SUPPLIER_STAFF_URL}${assignmentId}`)

    return data
}

export const getStaffDetails = async ({ staffAssignmentId }) => {
    const { data } = await axios.get(`${SUPPLIER_STAFF_DETAILS_URL}${staffAssignmentId}`)

    return data
}

export const changeStaffPictureProfile = async ({ staffId, file, staffNSS }) => {
    const allowedImageTypes = ["image/jpeg", "image/png", "image/webp"];

    if (!allowedImageTypes.includes(file.type)) {
        throw new Error('Invalid file type. Please upload a JPEG, PNG, or WEBP image.');
    }

    const formData = new FormData();
    formData.append("staffNSS", staffNSS);
    formData.append("document", file);

    const { data } = await axios.patch(`${SUPPLIER_STAFF_URL}picture/${staffId}`, formData);

    return data;
}

export const getStaffPayrollDetails = async ({ staffAssignmentId }) => {
    const { data } = await axios.get(`${SUPPLIER_STAFF_PAYROLL_URL}${staffAssignmentId}`)

    return data
}

export const addStaffDocument = async ({ staffAssignmentId, file }) => {
    if (file.type !== "application/pdf") {
        throw new Error("Only PDF files are accepted");
    }

    const formData = new FormData();
    formData.append("document", file);

    const { data } = await axios.post(`${SUPPLIER_STAFF_PAYROLL_URL}${staffAssignmentId}`, formData);

    return data;
}

export const removeStaffPayrollDocument = async ({ staffAssignmentId, documentId }) => {
    const { data } = await axios.delete(`${SUPPLIER_STAFF_PAYROLL_URL}${staffAssignmentId}/document/${documentId}`);  

    return data;
}
